module.exports = __webpack_public_path__ + "static/img/information-menu-image.de0f40d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/information-menu-image.jpg
// module id = g7ix
// module chunks = 1